export default "__VITE_ASSET__BCpGos64__"